import dispatcher from 'dispatcher';
import Api from 'utils/api';
import * as ActionConstants from '../../utils/ActionConstants';
import * as CreditConstants from './CreditConstants';

export function goTo(step, data) {
    let payload;
    console.log('STEP: ', step, CreditConstants.CREDIT_STEP2);

    switch (step) {
        case CreditConstants.CREDIT_STEP1: {
            payload = { state: CreditConstants.CREDIT_STEP1, data: {} };

            break;
        }
        case CreditConstants.CREDIT_STEP2: {
            payload = {
                state: CreditConstants.CREDIT_STEP2,
                data: data
            };
            break;
        }
        case CreditConstants.CREDIT_STEP3: {
            payload = {
                state: CreditConstants.CREDIT_STEP3,
                data: data
            };
            break;
        }
        case CreditConstants.CREDIT_STEP4: {
            payload = {
                state: CreditConstants.CREDIT_STEP4,
                data: data
            };
            break;
        }
        case CreditConstants.CREDIT_STEP5: {
            payload = {
                state: CreditConstants.CREDIT_STEP5,
                data: data
            };
            break;
        }
    }
    console.log(payload);
    dispatcher.dispatch({
        type: ActionConstants.GO_TO_NEXT_CREDIT_STEP,
        payload: payload
    });
}

export function sendApplication(creditApp) {
    Api.sendCreditApp(creditApp);
    // dispatcher.dispatch({
    //     type: ActionConstants.SEND_CREDIT_APPLICATION,
    //     payload: data
    // });
}

// export function sendQuote(step) {
//     Api.calcQuote(quoteForm).then((data) => {
//         console.log("QUOTE ACTION: ", data);
//         dispatcher.dispatch({
//             type:ActionConstants.CREATED_QUOTE,
//             payload: data.data.quote
//         });

//     }).catch((error)=>{
//         // dispatcher.dispatch({
//         //     type: ActionConstants.FAILED_TO_LOGIN,
//         //     payload: error
//         // });
//     });

// }



// WEBPACK FOOTER //
// ./src/app/pages/credit/CreditActions.js